module.exports = __webpack_public_path__ + "static/SezaneLogo-6209208d7e1c376746d21413e2560c49.jpg";